import {
  Component,
  EventEmitter,
  Output
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import { LineCellBaseComponent }
from '../line-cell-base/line-cell-base.component';

@Component({
  selector: 'app-line-cell-tax',

  standalone: true,

  imports: [
    CommonModule
  ],

  templateUrl: './line-cell-tax.component.html'
})
export class LineCellTaxComponent
extends LineCellBaseComponent {

  @Output()
  taxClick =
    new EventEmitter<void>();

  open(): void {

    this.taxClick.emit();
  }

  get taxAmount(): number {

    return Number(
      this.row.get('tax_amount')
        ?.value || 0
    );
  }
}